export default __webpack_public_path__ + "static/media/scheduled.4c38d047.svg";